module.exports = __webpack_public_path__ + "static/media/pawsnfind_marketing_BG.34ed0ca2.png";